import { HistoryIcon } from "lucide-react";
import type { FC } from "react";
import { Link, useLocation } from "react-router";

import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from "@/components/ui/tooltip";
import { getChatHistoryTab } from "@/pages/frontend/chat/chatRoutes";

interface ChatHistoryLinkProps {
    to: string;
    label: string;
}

export const ChatHistoryLink: FC<ChatHistoryLinkProps> = ({ to, label }) => {
    const tab = getChatHistoryTab(useLocation().pathname);
    const isCurrent = tab !== null && tab === getChatHistoryTab(to);

    return (
        <Tooltip>
            <TooltipTrigger
                render={
                    <Link
                        to={to}
                        aria-label={label}
                        aria-current={isCurrent ? "page" : undefined}
                        className="text-muted-foreground hover:bg-muted hover:text-foreground aria-[current=page]:bg-muted aria-[current=page]:text-foreground focus-visible:border-ring focus-visible:ring-ring/50 relative flex size-5 items-center justify-center rounded-md border border-transparent transition-colors outline-none after:absolute after:-inset-2 focus-visible:ring-3 motion-reduce:transition-none"
                    />
                }
            >
                <HistoryIcon aria-hidden="true" className="size-4" />
            </TooltipTrigger>
            <TooltipContent side="bottom">View all history</TooltipContent>
        </Tooltip>
    );
};

export const ChatHistoryViewAllRow: FC<ChatHistoryLinkProps> = ({
    to,
    label,
}) => (
    <Link
        to={to}
        aria-label={label}
        className="text-muted-foreground hover:bg-muted focus-visible:bg-muted flex h-9 items-center rounded-lg px-3 text-sm transition-colors focus-visible:outline-none motion-reduce:transition-none"
    >
        View all
    </Link>
);
